import BaseComponent from "../BaseComponent";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import ColorBoxInput from "components/Properties/InputComponents/ColorboxInput";
import DirectionInput from "components/Properties/InputComponents/DirectionInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";

const LightComponent = ({selectedObject, colorOnChange, transformOnChange, checkboxOnChange, inputOnChange}) => {
  const {name, color, intensity, castShadow} = selectedObject;
  const isPointLight = name === "PointLight";
  const isSpotLight = name === "SpotLight";
  const isHemisphereLight = name === "HemisphereLight";

  if (selectedObject.type.includes("Light")) {
    return (
      <BaseComponent title="Light" foldable={true}>
        <ToggleInput name="Shadow" checked={castShadow} checkboxOnChange={checkboxOnChange} />
        <ColorBoxInput name="LightColor" objectColor={"#" + color.getHexString()} colorOnChange={colorOnChange} />
        <NumberSliderInput name="Brightness" min={0} max={10} step={0.1} value={intensity} inputOnChange={inputOnChange} />
        {(isPointLight || isSpotLight) && (
          <NumberSliderInput name="Distance" min={1} max={1000} value={selectedObject.distance} inputOnChange={inputOnChange} />
        )}
        {isSpotLight && (
          <DirectionInput
            name="Target"
            value={{
              x: selectedObject.target.position.x,
              y: selectedObject.target.position.y,
              z: selectedObject.target.position.z,
            }}
            transformOnChange={transformOnChange}
          />
        )}
        {isHemisphereLight && (
          <>
            <ColorBoxInput name="LightColor" objectColor={"#" + selectedObject?.color.getHexString()} colorOnChange={colorOnChange} />
            <ColorBoxInput
              name="GroundColor"
              objectColor={"#" + selectedObject?.groundColor.getHexString()}
              colorOnChange={colorOnChange}
            />
          </>
        )}
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default LightComponent;
